import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardRoutingModule } from './dashboard-routing.module';
import { DashboardComponent } from './dashboard.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SharedModule } from '../shared/shared.module'; // Import the SharedModule Using the language Translate
import { RevenueChartComponent } from './revenue/revenue.component';


@NgModule({
    imports: [
        CommonModule,
        DashboardRoutingModule,
        MatButtonModule,
        MatCheckboxModule,
        SharedModule,
        DashboardComponent, RevenueChartComponent
    ],
    exports: [
        DashboardComponent,
        MatButtonModule,
        MatCheckboxModule,
        RevenueChartComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DashboardModule { }
